import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCircleNotch,
  faTimes,
  faGripLines,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import {} from "@fortawesome/free-brands-svg-icons";

// eslint-disable @typescript-eslint/no-explicit-any
library.add(
  faCircleNotch as any,
  faTimes as any,
  faGripLines as any,
  faCheck as any,
);
